import {Action, createAction, ThunkAction} from "@reduxjs/toolkit";
import {resetAction} from "careand-redux/utils/makeResettable";
import {Device} from "services/Native/Device";
import {navigationActions, Stacks} from "careand-redux/slices/ui/navigation";
import {removePushToken} from "services/updatePushToken";
import config from 'config/config.json'

const isPatient = !!(config as any).PATIENT

type LogoutPayload = {
  previousUserId?: string
} | undefined

const logoutAction = createAction<LogoutPayload>('logout')

const logoutThunk = (payload?: LogoutPayload): ThunkAction<void, unknown, unknown, Action<any>> => (dispatch) => {
  if (Device.isMobile()) {
    removePushToken()
    Device.storeCredentials(undefined)
  }
  dispatch(resetAction()) // resets all resettable slices
  dispatch(logoutAction(payload)) // dispatches logoutAction
  dispatch(navigationActions.resetState());
  if (!isPatient) {
    dispatch(navigationActions.pushedAsFirst({stack: Stacks.Master, to: '/login', animation: 'push'}))
  }
}

logoutThunk.action = logoutAction

/**
 * Logout thunk and action
 * can be dispatched: `dispatch(logout())`
 * or listened in a slice: `builder.addCase(logout.action, () => { ... })`
 */
export const logout: (typeof logoutThunk) & { action: typeof logoutAction } = logoutThunk
